/**
 * product-thumbnails-swiper.js
 * Boost Oxygen / Reformation – Swiper thumbs gallery
 *
 * Requires Swiper JS already loaded on the page (theme handles it).
 *
 * Gallery structure:
 *   Slot 0  — variant featured image (inner HTML swapped on variant change)
 *   Slots 1+ — unlinked/general images (static, never change)
 */

(function () {
  'use strict';

  if (customElements.get('product-slider-thumbnails-swiper')) return;

  class ProductSliderThumbnailsSwiper extends HTMLElement {

    connectedCallback() {
      this._waitForSwiper(this._init.bind(this));
    }

    disconnectedCallback() {
      if (this._ro)           { this._ro.disconnect(); }
      if (this._swiperMain)   { this._swiperMain.destroy(true, true); }
      if (this._swiperThumbs) { this._swiperThumbs.destroy(true, true); }
    }

    _waitForSwiper(callback) {
      var attempts = 0;
      var check = function () {
        attempts++;
        if (typeof window.Swiper !== 'undefined') { setTimeout(callback, 0); return; }
        if (attempts >= 50) { console.warn('[THB-SWIPER] Swiper never loaded.'); return; }
        setTimeout(check, 100);
      };
      check();
    }

    _init() {
      var imgContainer = this.closest('.product-image-container--thumbnails-swiper');
      if (!imgContainer) { console.warn('[THB-SWIPER] container not found'); return; }

      var mainEl    = imgContainer.querySelector('.thb-swiper-main');
      var thumbEl   = imgContainer.querySelector('.thb-swiper-thumbs');
      var thumbWrap = imgContainer.querySelector('.thb-swiper-thumbs-wrap');
      var thumbPrev = thumbWrap ? thumbWrap.querySelector('.swiper-btn--prev') : null;
      var thumbNext = thumbWrap ? thumbWrap.querySelector('.swiper-btn--next') : null;

      if (!mainEl || !thumbEl) { console.warn('[THB-SWIPER] swiper elements not found'); return; }

      /* Thumb swiper — initialise first */
      this._swiperThumbs = new Swiper(thumbEl, {
        spaceBetween: 8,
        slidesPerView: 4,
        slidesPerGroup: 1,
        freeMode: true,
        watchSlidesProgress: true,
        on: {
                  init: function() {
                    if (this.isLocked) {
                      thumbWrap.classList.add('swiper-nav-hidden');
                    }
                  },
                  resize: function() {
                    if (this.isLocked) {
                      thumbWrap.classList.add('swiper-nav-hidden');
                    } else {
                      thumbWrap.classList.remove('swiper-nav-hidden');
                    }
                  }
                },
        navigation: {
          prevEl: thumbPrev,
          nextEl: thumbNext,
        },
        breakpoints: {
          0:   { slidesPerView: 4, spaceBetween: 4 },
          480: { slidesPerView: 4, spaceBetween: 6 },
          640: { slidesPerView: 4, spaceBetween: 8 },
        },
        a11y: {
          prevSlideMessage: 'Previous thumbnail',
          nextSlideMessage: 'Next thumbnail',
        },
      });

      /* Build mobile counter nav */
      var mobileNav = document.createElement('div');
      mobileNav.className = 'thb-swiper-mobile-nav';

      var mobilePrev = document.createElement('button');
      mobilePrev.type = 'button';
      mobilePrev.className = 'thb-swiper-mobile-btn thb-swiper-mobile-btn--prev';
      mobilePrev.setAttribute('aria-label', 'Previous image');
      mobilePrev.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>';

      var mobileCounter = document.createElement('span');
      mobileCounter.className = 'thb-swiper-mobile-counter';
      mobileCounter.textContent = '1 / 1';

      var mobileNext = document.createElement('button');
      mobileNext.type = 'button';
      mobileNext.className = 'thb-swiper-mobile-btn thb-swiper-mobile-btn--next';
      mobileNext.setAttribute('aria-label', 'Next image');
      mobileNext.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>';

      mobileNav.appendChild(mobilePrev);
      mobileNav.appendChild(mobileCounter);
      mobileNav.appendChild(mobileNext);

      var galleryWrap = imgContainer.querySelector('.thb-swiper-gallery-wrap');
      if (galleryWrap && galleryWrap.parentNode) {
        galleryWrap.parentNode.insertBefore(mobileNav, galleryWrap.nextSibling);
      }

      /* Main swiper linked to thumb swiper */
      var self = this;
      this._swiperMain = new Swiper(mainEl, {
        spaceBetween: 0,
        thumbs: {
          swiper: this._swiperThumbs,
        },
        a11y: {
          prevSlideMessage: 'Previous image',
          nextSlideMessage: 'Next image',
        },
        on: {
          afterInit: function (swiper) {
            var total = swiper.slides.length;
            mobileCounter.textContent = '1 / ' + total;
            mobilePrev.classList.add('swiper-button-disabled');
            if (total <= 1) { mobileNext.classList.add('swiper-button-disabled'); }
          },
          slideChange: function (swiper) {
            var current = swiper.activeIndex + 1;
            var total   = swiper.slides.length;
            mobileCounter.textContent = current + ' / ' + total;
            mobilePrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
            mobileNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
          }
        }
      });

      mobilePrev.addEventListener('click', function () {
        if (self._swiperMain) { self._swiperMain.slidePrev(300); }
      });
      mobileNext.addEventListener('click', function () {
        if (self._swiperMain) { self._swiperMain.slideNext(300); }
      });

      /* ── Variant change — swap slot 0 content only ─────────
         product.js dispatches product:swiper-variant-change with
         { mediaId, variantId, sectionId } after renderVariantInfo()
         fetch completes and currentVariant is correct.

         We fetch the section HTML for the new variant and extract
         the new slot 0 media/thumbnail HTML, then swap only those
         two slide contents. The rest of the slides stay untouched.
         No Swiper destroy/reinit needed. ─────────────────────── */
      var self2       = this;
      var productUrl  = document.querySelector('.thb-product-detail') ?
                        document.querySelector('.thb-product-detail').dataset.handle : null;
      var sectionEl   = imgContainer.closest('[id^="shopify-section-"]');
      var sectionId   = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;

      document.addEventListener('product:swiper-variant-change', function (e) {
        var mediaId   = e.detail.mediaId;
        var variantId = e.detail.variantId;
        if (!mediaId || !variantId || !sectionId || !productUrl) return;

        /* Slot 0 elements */
        var mainSlot0  = mainEl.querySelector('.thb-variant-slide');
        var thumbSlot0 = thumbEl.querySelector('.thb-variant-slide');
        if (!mainSlot0 || !thumbSlot0) return;

        /* Show loading state */
        mainSlot0.classList.add('thb-loading');
        thumbSlot0.classList.add('thb-loading');

        /* Fetch section HTML for the selected variant */
        fetch('/products/' + productUrl + '?variant=' + variantId + '&section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            /* Extract the new slot 0 main slide inner HTML */
            var newMainSlot = doc.querySelector('.thb-variant-slide');
            if (newMainSlot) {
              mainSlot0.innerHTML = newMainSlot.innerHTML;
            }

            /* Extract the new slot 0 thumb slide inner HTML */
            var newThumbSlot = doc.querySelector('.thb-swiper-thumbs .thb-variant-slide');
            if (newThumbSlot) {
              thumbSlot0.innerHTML = newThumbSlot.innerHTML;
              thumbSlot0.dataset.mediaId = newThumbSlot.dataset.mediaId || String(mediaId);
            }

            mainSlot0.classList.remove('thb-loading');
            thumbSlot0.classList.remove('thb-loading');

            /* Slide to index 0 so the new variant image is shown */
            if (self2._swiperMain)   { self2._swiperMain.slideTo(0, 300); }
            if (self2._swiperThumbs) { self2._swiperThumbs.slideTo(0, 300); }
          })
          .catch(function (err) {
            console.warn('[THB-SWIPER] Slot 0 swap failed:', err);
            mainSlot0.classList.remove('thb-loading');
            thumbSlot0.classList.remove('thb-loading');
          });
      });

      /* ResizeObserver — whenever the image container changes size
         force both Swiper instances to recalculate their dimensions */
      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(function () {
          if (self._swiperThumbs) { self._swiperThumbs.update(); }
          if (self._swiperMain)   { self._swiperMain.update(); }
        });
        this._ro.observe(imgContainer);
      }

      /* Force update after layout settles */
      var updateBoth = function () {
        if (self._swiperThumbs) { self._swiperThumbs.update(); }
        if (self._swiperMain)   { self._swiperMain.update(); }
      };
      requestAnimationFrame(function () {
        updateBoth();
        setTimeout(updateBoth, 300);
        setTimeout(updateBoth, 600);
      });
    }
  }

  customElements.define('product-slider-thumbnails-swiper', ProductSliderThumbnailsSwiper);

})();